import React, { PropsWithChildren } from 'react';

import { FeaturePatternTrussContainer } from '@paragon/contract-library';
import { getModifierKeys } from '@paragon/utilities';

import { useAppDispatch } from '../../../components/hooks';
import {
  handleStandardSceneItemEditPropertiesAction,
  handleStandardSceneItemRightClick,
} from '../../../store/actions/sceneInteractionActions';
import { selectItem } from '../../../store/actions/selectActions';
import { clearHoverItemIfActive, ensureHoverItemIsActive } from '../../../store/actions/viewportActions';
import { threeJsDom } from '../../util/events/ThreeJSDom';

interface Props extends PropsWithChildren {
  container: FeaturePatternTrussContainer | Omit<FeaturePatternTrussContainer, 'guid'>;
}

export function FeaturePatternContainerEventHandlers({ container, children }: Props) {
  const dispatch = useAppDispatch();

  if (!('guid' in container)) return children;

  const interactionHandle = { type: 'featurePatternContainer', guid: container.guid, origin: 'fiber' } as const;

  return (
    <group
      onClick={(event) => {
        if (event.detail === 2) {
          event.stopPropagation();
          dispatch(handleStandardSceneItemEditPropertiesAction('featurePatternContainer', container));
        } else if (threeJsDom.shouldDispatchClickEvent()) {
          event.stopPropagation();
          dispatch(
            selectItem(container, 'featurePatternContainer', {
              intent: 'toggle',
              exclusive: !getModifierKeys(event).ctrlKey,
            }),
          );
        }
      }}
      onContextMenu={async (event) => {
        dispatch(handleStandardSceneItemRightClick(event, interactionHandle));
      }}
      onPointerOver={(event) => {
        event.stopPropagation();
        dispatch(ensureHoverItemIsActive(interactionHandle));
      }}
      onPointerOut={() => {
        dispatch(clearHoverItemIfActive(interactionHandle));
      }}
    >
      {children}
    </group>
  );
}
